var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3346 13.3327H4.0013C3.26492 13.3327 2.66797 12.7357 2.66797 11.9993V4.66602C2.66797 3.92964 3.26492 3.33268 4.0013 3.33268H6.66797V4.66602H4.0013V11.9993H11.3346V9.33268H12.668V11.9993C12.668 12.7357 12.071 13.3327 11.3346 13.3327ZM7.8013 9.13735L6.8613 8.19468L11.0566 3.99935H8.66797V2.66602H13.3346V7.33268H12.0013V4.94268L7.8013 9.13735Z",
    fill: "#929DA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkExternal);
export default __webpack_public_path__ + "static/media/link-external.2ad524aff36eb103761b87ec95df6cc6.svg";
export { ForwardRef as ReactComponent };